document.addEventListener("DOMContentLoaded", function () {

  const popup = document.getElementById("fabric-popup");
  const descEl = document.getElementById("fabric-popup-description");
  const closeBtn = document.querySelector(".fabric-popup__close");
  const fabricProduct = document.getElementById("fabric-product-data");
  const fabricDataEl = document.getElementById("fabric-data");

  window.openFabricPopup = function (optionName) {

    // ✅ find color container
    

   const colorContainer = document.querySelector(
  `.swatches__container[data-option-name="${optionName}"]`
);

    if (!colorContainer) {
      console.log("Color container not found");
      return;
    }

    // ✅ selected color input
    const activeColorInput = colorContainer.querySelector('input:checked');

    if (!activeColorInput) {
      console.log("No color selected");
      return;
    }

    const value = activeColorInput.value;

    // ✅ key generate (IMPORTANT)
    const rawKey = value
  .toLowerCase()
  .replace(/[^a-z0-9\s-]/g, '') // remove all special characters
  .trim()
  .replace(/\s+/g, '-');

    const camelKey = rawKey.replace(/-([a-z])/g, (g) => g[1].toUpperCase());


    // ✅ DESCRIPTION (richtext support)
    const rawDescription = fabricDataEl?.dataset[camelKey] || "No description available";

    // decode HTML entities
    function decodeHTML(html) {
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }

    const description = decodeHTML(rawDescription);

    // ✅ PRODUCT CONTENT
    const productEl = document.querySelector(
      `#fabric-products [data-key="${rawKey}"]`
    );

    const productContent = productEl ? productEl.innerHTML : "";


    // description
  if (productContent && productContent.trim() !== "") {
  // ❌ hide description if product exists
  descEl.style.display = "none";
} else {
  // ✅ show description only if no product
  descEl.style.display = "block";
  descEl.innerHTML = description;
}

    // product block
    if (fabricProduct) {
      fabricProduct.innerHTML = productContent;
    }

    // open popup
    popup.classList.add('active');
  };

  // ✅ close button
  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      popup.classList.remove('active');
    });
  }

  // ✅ outside click close
  popup.addEventListener('click', function(e) {
    if (e.target === this) {
      this.classList.remove('active');
    }
  });

 document.addEventListener('click', function(e) {

  const btn = e.target.closest('.fabric-add-to-cart');
  if (!btn) return;

  e.preventDefault();

  // prevent double click
  if (btn.classList.contains('loading')) return;

  const originalText = btn.innerText;

  // ✅ loading state
  btn.classList.add('loading');
  btn.innerText = "Adding...";

  const variantId = btn.dataset.variantId;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(res => res.json())
  .then(data => {

    // ✅ success state
    btn.classList.remove('loading');
    btn.classList.add('added');
    btn.innerText = "Added ✓";

    // reset after 2 sec
    setTimeout(() => {
      btn.classList.remove('added');
      btn.innerText = originalText;
    }, 2000);

  })
  .catch(err => {
    console.error(err);

    btn.classList.remove('loading');
    btn.innerText = "Error ❌";

    setTimeout(() => {
      btn.innerText = originalText;
    }, 2000);
  });

});

});